import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

import { ButtonStandard, DeclarationFilter } from "../../components";
import "./DeclarationList.scss"
import messages from "../../assets/i18n";
import ItemList from '../../containers/ItemList/ItemList'
import { downloadFile } from '../../utils/utilFile';

function DeclarationList(props) {

	const dispatch = useDispatch();
	const history = useHistory();

	const lang = useSelector(state => state.language.name);

	const declarationList = useSelector(state => state.producerDeclaration.declarationList);
	const declarationCsvList = useSelector(state => state.producerDeclaration.declarationCsvList);
	const declarationCsvLoading = useSelector(state => state.producerDeclaration.declarationCsvLoading);
	const declarationState = useSelector(state => state.producerDeclaration);
	const selectedDeclaration = useSelector(state => state.producerDeclaration.selectedProducerDeclaration);
	const downloadDeclarationFile = useSelector(state => state.producerDeclaration.downloadDeclarationFile);
	const downloadDeclarationLoading = useSelector(state => state.producerDeclaration.downloadDeclarationLoading);

    const [declarationId, setDeclarationId] = useState(undefined);
    const [pedido, setPedido] = useState(undefined);

	const pageMessages = messages[lang].declarationListPage;
	const titleTable = messages[lang].declarations;
	const titlePage = messages[lang].declarationsInquiry;

	const header = [
		pageMessages.numeroPedido,
		pageMessages.status,
		pageMessages.fornecedor,
		pageMessages.dtCadastro,
		pageMessages.statusRMS,
		pageMessages.motivoErro,
		pageMessages.statusFecomercio,
		pageMessages.normaDeclaracaoProdutor,
		pageMessages.detalhes,
		pageMessages.download,
	];

	let headerCsv = [
		pageMessages.numeroPedido,
		pageMessages.status,
		pageMessages.statusFecomercio,
		pageMessages.statusRMS,
		'Protocolo Fecomercio',
		pageMessages.fornecedor,
		pageMessages.dtCadastro,
		pageMessages.normaDeclaracaoProdutor
	];

	const filters = useSelector(state => state.declarationFilter.filter);

	const [statusError, setStatusError] = useState('-');

	useEffect(() => {
		dispatch({
			type: 'GET_DECLARATIONS',
			page: declarationState.page,
			filter: filters
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (selectedDeclaration) {
			history.push({
				pathname: '/declaration-details',
				erroRMS: statusError,
			})
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedDeclaration]);

	const handleHasMore = () => {
		dispatch({
			type: 'GET_DECLARATIONS',
			page: declarationState.page,
			filter: filters
		})
	}

	const formatDateHour = date => {
		let dateSplit = date.split('-')
		let daySplit = dateSplit[2].split(' ')
		let hourSplit = daySplit[1].split(':')
		let returnDate = `${daySplit[0]}/${dateSplit[1]}/${dateSplit[0]} ${hourSplit[0]}:${hourSplit[1]}`

		return returnDate; 
	  } 

	const mappedDeclarationList = () => {
		return declarationList.map((item) => {
			return [
				item.pedido.id,
				item.status ? item.status.descricao : '-',
				{
					text: item.pedido.fornecedor.nome,
					maxLength: 70
				},
				item.dataCadastro
				?
					{					
						text: item.dataCadastro,
						type: 'datehour',
					}
				:
					{
						text: '--/--/----'
					},
				item.statusRMS ? item.statusRMS.descricao : '-',
				item.erroEnvioRMS
					?
					{
						text: item.erroEnvioRMS,
						maxLength: 30
					}
					:
					'-',
				{
					text: item.statusFecomercio.descricao
				},
				{
					text: item.normaDeclaracaoProdutor ? item.normaDeclaracaoProdutor.codigo : '-'
				},
				{
					text: <i className="icon-pen" />,
					onClick: () => {
						if (item.erroEnvioRMS) {
							setStatusError(item.erroEnvioRMS)
						}

						dispatch({
							type: 'SET_SELECTED_DECLARATION',
							payload: { id: item.id, pedido: item.pedido.id }
						})
					},
				},
				{
					text: <ButtonStandard
							icon="icon-download"
							isLoading={downloadDeclarationLoading && item.id === declarationId}
							disabled={downloadDeclarationLoading && item.id !== declarationId}
							className="btn btn-light btn-rounded btn-hover"
							onClick={() => handleDownloadFile(item)} />
				}
			]

		});
	}

	const handleDownloadFile = (item) => {
		setDeclarationId(item.id);
		setPedido(item.pedido.id);
		dispatch({
			type: 'GET_DECLARATION_FILE_DOWNLOAD',
			payload: item.id
		})
	}

	useEffect(() => {
		if (downloadDeclarationFile) {
			downloadPdf(downloadDeclarationFile);
			dispatch({ type: "SET_DOWNLOAD_DECLARATION_FILE", payload: undefined});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [downloadDeclarationFile]);

    const downloadPdf = (file) => {
		const byteCharacters = window.atob(file);
		const byteNumbers = new Array(byteCharacters.length);
		for (let i = 0; i < byteCharacters.length; i++) {
			byteNumbers[i] = byteCharacters.charCodeAt(i);
		}
		const byteArray = new Uint8Array(byteNumbers);
		const blob = new Blob([byteArray], { type: 'application/pdf' });

		const link = document.createElement('a');
		link.href = window.URL.createObjectURL(blob);

		let extension = 'pdf'

		if (file[0] === '0' || file[0] === 'O') {
			extension = 'doc'
		} else if (file[0] === 'U') {
			extension = 'docx'
		}

		link.download = messages[lang].filePDFProducerDeclarationFormat.replace('$1', pedido) + '.' + extension;
		link.click();
	}

	const getDeclarations = () => {
		dispatch({
			type: 'GET_DECLARATIONS',
			page: 1,
			filter: filters,
			cleanTable: true
		})
	}

	useEffect(() => {
		if (declarationCsvList.length > 0) {
			let transformDeclarationToDownload =
				declarationCsvList
					.map(item => ([
						item.pedido.id,
						item.status ? item.status.descricao : '-',
						item.statusFecomercio.descricao,
						item.statusRMS ? item.statusRMS.descricao : '',
						'',
						item.pedido.fornecedor.nome,
						item.dataCadastro ? formatDateHour(item.dataCadastro) : '',
						item.normaDeclaracaoProdutor ? item.normaDeclaracaoProdutor.codigo : ''
					]));
			
			const filename = titleTable + `.csv`;
			const textCsv = mountCsvText([headerCsv, ...transformDeclarationToDownload]);
			downloadFile(textCsv, filename);
			
			dispatch({
				type: 'SET_DECLARATION_CSV_LIST',
				payload: []
			})
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [declarationCsvList]);

	const handleDownloadAllDeclarations = () => {
		dispatch({
			type: 'GET_DECLARATION_CSV_DOWNLOAD',
			page: 1,
			filter: filters,
			cleanTable: true
		})
	}

	const mountCsvText = (arrayToText) => {
		const separator = ';';
		return arrayToText.reduce((csvText, currentRow) => {

			const rowText = currentRow.reduce((csvRow, currentColumn) => {
				return csvRow ? `${csvRow}${separator}${currentColumn}` : currentColumn
			}, '');

			return csvText ? `${csvText}\n${rowText}` : rowText
		}, '');
	}


	return (
		<div className="declaration-list-page">
			<Container className="pt-3 justify-content-start">
				<Row className="justify-content-between">
					<Col className="d-flex align-items-center justify-content-start">
						<span className="text-3 font-weight-bold header-main pl-2">{titlePage}</span>
					</Col>
				</Row>
				<DeclarationFilter />
			</Container>

			<Container className="px-4 d-flex justify-content-end">
				<ButtonStandard
					text={messages[lang].downloadAll}
					isLoading={declarationCsvLoading}
					textClass="text-1"
					className="btn-primary btn-sm btn-standard px-2 mr-2"
					onClick={() => handleDownloadAllDeclarations()} />
				<ButtonStandard
					text={messages[lang].searchDeclaration}
					textClass="text-1"
					className="btn-sm btn-outline-success btn-standard px-2 mr-2"
					onClick={() => getDeclarations()} />
			</Container>

			<Container className="pt-3 justify-content-start">
				<Container className="mt-1 pt-1 mb-4 pb-5">
					<ItemList
						header={header}
						titleTable={titleTable}
						listTable={mappedDeclarationList()}
						isLoading={declarationList.length > 0 ? false : true}
						hasMore={declarationState.hasMore}
						handleHasMore={handleHasMore}
						hasMoreIsLoading={declarationState.hasMoreIsLoading}
					/>
				</Container>
			</Container>
		</div>
	)
}

export default withRouter(DeclarationList);